module.exports = __webpack_public_path__ + "static/media/Soundborder.861a9372.webp";